import React from "react";

export const COMMON_DATA_REQUESTED = 'COMMON_DATA_REQUESTED';
export const COMMON_DATA_LOADED = 'COMMON_DATA_LOADED';

const SET_ONBOARDING_STATUS = "visitors/SET_ONBOARDING_STATUS";

export const commonDataRequested = (module) => ({
    type: `${module}/${COMMON_DATA_REQUESTED}`,
})

export const commonDataLoaded = (module, payload) => ({
    type: `${module}/${COMMON_DATA_LOADED}`,
    payload
});

export const setOnboardingStatus = (tag, status) => ({
    type: SET_ONBOARDING_STATUS,
    payload: {
        tag: tag,
        status: status
    }
})

export const initialState = {
    commonModuleDataUpdatedAt: false,
    currentUser: {}, // TODO - move into globalReducer/store and refactor out from common
    prototypes: {},
    config: {},
    permissions: {},
    formOptions: {},
    onboarding: {},
};

export const commonReducerFor = (module) => {
    return (state = initialState, action) => {
        switch (action.type) {

            case `${module}/${COMMON_DATA_REQUESTED}`:
                return {
                    ...state,
                    commonModuleDataUpdatedAt: new Date().toISOString()
                }

            case `${module}/${COMMON_DATA_LOADED}`:
                let newState = {...state};

                if (action.payload.config) {
                    newState.config = {...action.payload.config};
                }

                if (action.payload.strings) {
                    newState.strings = {...action.payload.strings};
                }

                if (action.payload.permissions) {
                    newState.permissions = {...action.payload.permissions};
                }

                if (action.payload.formOptions) {
                    newState.formOptions = {...action.payload.formOptions};
                }

                if (action.payload.prototypes && action.payload.formOptions) {
                    let prototypes = setDefaultsOnPrototypes(module, action.payload.prototypes, action.payload.formOptions);
                    newState.prototypes = {...prototypes};
                }

                if (action.payload.onboarding) {
                    newState.onboarding = {...action.payload.onboarding}
                }

                newState.commonModuleDataUpdatedAt = new Date().toISOString();

                return newState;

            case SET_ONBOARDING_STATUS: {
                return {
                    ...state,
                    onboarding: {
                        ...state.onboarding,
                        [action.payload.tag]: action.payload.status
                    }
                }
            }

            default: {
                return state;
            }
        }
    }
}

/**
 * We might want to initialise the object prototypes with certain values
 * (depending on what module this is).
 *
 * If so, it gets done here.
 *
 * TODO - I've never been happy with this, surely there's a better way, or a way to avoid having to do this altogether? Perhaps it can just be done server-side
 */
const setDefaultsOnPrototypes = (module, prototypes, formOptions) => {
    if (module === 'VISITORS') {
        return {
            ...prototypes,
            host: {
                ...prototypes.host,
                _isCollapsed: false
            },
            visit: {
                ...prototypes.visit,
                entrance_id: formOptions.entrances[0].value ?? null,
                _isCollapsed: false
            },
            visitor: {
                ...prototypes.visitor,
                visitor_type_id: formOptions.visitorTypes[0].value ?? null,
                _isCollapsed: false,
                _isBusy: false,
                _isSignInExpanded: false
            }
        };
    }
}
